module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ChatView.js"));
	}, "ChatView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChatView!./src/pages/TIM/Chat/ChatView.js
// module id = 2244
// module chunks = 367